import React, { Component } from 'react';

class Spinner extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    componentDidMount(){
        // $(".spinClass").load("https://smallseotools.com/plagiarism-checker/")
    }
    render() { 
        return ( 
            <div>
                {/* <script type="text/javascript" src="www.prepostseo.com/widget-article-rewriter.js?"></script> */}
                <iframe style={{width:`50vw`,height:`50vh`}} src="https://smallseotools.com/plagiarism-checker/#filesForm"></iframe>
                {/* <div style={{width:`50vw`,height:`50vh`}} class="spinClass"></div> */}
                <div>
                    <p>
                        <a href="https://www.prepostseo.com/free-online-article-rewriter" target="_blank" >Article rewriter</a> provided by <a href="https://www.prepostseo.com/" target="_blank">prepostseo.com</a></p></div>

            </div>
         );
    }
}
 
export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.js